import { G_BUTTON__image_crop_box_maximize } from './_buttons/G_BUTTON__image_crop_box_maximize';

export function G_SIDEBAR__IMAGE_EDIT__crop_box() {
  return (
    <div className="size-full flex flex-col items-start justify-start gap-2 p-2">
      <G_BUTTON__image_crop_box_maximize />
    </div>
  );
}
